import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

const FormGroupPart = ({ children, label, labelClassName, labelCols, inputCols, invalid }) => (
  <Fragment>
    <label className={classnames(labelClassName, labelCols)}>
      {label && label.id ? <FormattedMessage {...label} /> : label}
    </label>
    <div className={classnames(inputCols, { fieldError: invalid })}>{children}</div>
  </Fragment>
);
FormGroupPart.propTypes = {
  children: PropTypes.node,
  label: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.shape({ id: PropTypes.string.isRequired }),
  ]),
  labelClassName: PropTypes.string,
  labelCols: PropTypes.string,
  inputCols: PropTypes.string,
  invalid: PropTypes.bool,
  labelAlign: PropTypes.oneOf(['left', 'right', 'center']),
};
FormGroupPart.defaultProps = {
  children: null,
  label: null,
  labelClassName: '',
  labelCols: 'col-sm-2',
  inputCols: 'col-sm-4',
  invalid: false,
  labelAlign: 'left',
};
export default FormGroupPart;
